module.exports = __webpack_public_path__ + "static/media/dropdown.adbb646f.svg";